export const MESSAGES_SET_SELECTED_ROW_IDS = 'messagesSetSelectedRowIds'

export type MessagesTableDispatch = (action: { type: string; selectedRowIds?: Record<string, boolean> }) => void

export const ROW_SELECT_ACTIONS = ['toggleRowSelected', 'toggleAllPageRowsSelected', 'toggleAllRowsSelected'] as const

/** API max page size for custom blast and automated message paged endpoints. */
export const MESSAGES_FETCH_ALL_PAGE_SIZE = 100
